import React from "react";

import { AccountingChart as AccountingChartModule } from "@aclymatepackages/modules";

import useDisplayMeasurementSystem from "../../../helpers/hooks/displayMeasurementSystem";

const AccountingChart = (props) => {
  const { convertCarbonUnits, carbonUnitLabel } = useDisplayMeasurementSystem();

  return (
    <AccountingChartModule
      {...props}
      convertCarbonUnits={convertCarbonUnits}
      displayUnitLabel={carbonUnitLabel}
    />
  );
};
export default AccountingChart;
